export function isFunction(x:any) {
    return Object.prototype.toString.call(x) === '[object Function]';
}

